module.exports = __webpack_public_path__ + "img/23_84.1df00948.png";